module.exports = __webpack_public_path__ + "assets/img/fairown-granngarden-lawnmower-hero.7a6e4113.jpg";